import { render, staticRenderFns } from "./RewardWarn.vue?vue&type=template&id=cc11a2ba&scoped=true"
import script from "./RewardWarn.vue?vue&type=script&lang=js"
export * from "./RewardWarn.vue?vue&type=script&lang=js"
import style0 from "./RewardWarn.vue?vue&type=style&index=0&id=cc11a2ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc11a2ba",
  null
  
)

export default component.exports